import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const MississippiMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg
			id='mississippi'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1000 1000'
			className='map'>
			<polygon
				id='MS_ZS'
				points='278.73 522.69 301.73 561.69 303.73 594.69 302.73 622.69 286.73 650.69 255.73 695.69 237.73 748.69 229.73 804.69 492.73 786.69 494.73 799.69 483.73 823.69 480.73 843.69 496.73 868.69 512.73 887.69 539.73 917.69 559.6 891.69 587.73 879.69 623.73 876.69 655.73 879.69 676.73 878.69 690.73 872.69 679.73 850.69 651.73 638.69 653.67 471.1 278.73 522.69'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'MS_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('MS_ZS')}
			/>
			<polygon
				id='MS_ZN'
				points='653.67 471.1 657.73 119.69 370.73 145.69 351.73 175.69 344.73 203.69 332.73 239.69 300.73 283.69 292.73 314.69 268.73 355.69 266.73 382.69 276.73 410.69 278.73 433.69 274.73 478.69 278.73 522.69 653.67 471.1'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'MS_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('MS_ZN')}
			/>
			<rect x='508.38' y='626.8' width='59.85' height='43.33' fill='none' className='shape' />
			<path
				d='M507.77,666.32l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M542.25,663.14c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.7-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect
				x='387.07'
				y='370.77'
				width='73.15'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M386.46,410.29l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M420.32,413.37l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<polygon
				points='601.12 504.4 601.23 508.73 605.77 508.73 601.29 511.4 601.4 515.72 598.52 513.05 594.04 515.72 596.75 511.4 593.87 508.73 598.42 508.73 601.12 504.4'
				className='shape'
			/>
			<rect x='489.95' y='516.27' width='104.9' height='20' fill='none' className='shape' />
			<path
				d='M504.25,533.31l1.16-8.74c.21-1.54.57-3.91.88-5.47h-.08c-.75,1.63-1.65,3.56-2.53,5.21l-4.81,8.9h-1.52l-1.2-8.71c-.25-1.86-.41-3.74-.52-5.39h-.05c-.34,1.49-.85,3.94-1.23,5.48l-2.2,8.73h-1.87l4.19-16.18h2.54l1.28,9.28c.16,1.38.35,2.85.39,4.06h.07c.49-1.2,1.18-2.65,1.88-4l5.01-9.33h2.6l-2.05,16.18h-1.94Z'
				className='shape'
			/>
			<path
				d='M520.15,532.65c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.24,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM517.94,522.99c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.76-1.48Z'
				className='shape'
			/>
			<path
				d='M525.07,533.31l1.42-7.48c.29-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M535.1,533.31l2.22-11.61h1.99l-2.22,11.61h-1.99ZM537.69,518.46c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M555.37,516.27l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM552.03,523.52c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.41.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<path
				d='M558.04,533.31l2.22-11.61h1.99l-2.22,11.61h-1.99ZM560.63,518.46c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M573.66,533.31c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.5,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM574.95,523.19c-.28-.09-.71-.17-1.38-.17-3,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M580.96,533.31l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<polygon
				points='370.36 543.79 370.47 548.11 375.02 548.11 370.54 550.79 370.64 555.11 367.77 552.44 363.29 555.11 365.99 550.79 363.11 548.11 367.66 548.11 370.36 543.79'
				className='shape'
			/>
			<rect x='371.59' y='555.66' width='93.47' height='20' fill='none' className='shape' />
			<path
				d='M371.28,570.84c.53.22,1.18.35,2.04.35,1.7,0,2.77-.9,3.31-3.76l2.07-10.91h1.99l-2.11,11.13c-.71,3.79-2.29,5.31-5.32,5.31-.98,0-1.99-.21-2.4-.42l.43-1.7Z'
				className='shape'
			/>
			<path
				d='M391.17,572.7c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.5,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM392.47,562.58c-.28-.09-.71-.16-1.38-.16-3,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M406.42,572.24c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.03-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.11,2.89,3.11,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M411.01,572.7l3.24-17.04h1.98l-2.04,10.68h.05c.35-.41.78-.85,1.09-1.17l4.09-4.08h2.46l-5.06,4.77,3.46,6.84h-2.19l-2.79-5.73-1.47,1.31-.83,4.42h-1.98Z'
				className='shape'
			/>
			<path
				d='M424.47,570.68c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.86.56,1.37,1.59,1.96,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M446.89,565.66c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.15-4.53-4.77,0-3.84,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM437.96,568.12c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M450.7,572.7l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.48,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<polygon
				points='620.6 857.45 620.71 861.77 625.26 861.77 620.78 864.44 620.88 868.76 618.01 866.09 613.53 868.76 616.23 864.44 613.35 861.77 617.9 861.77 620.6 857.45'
				className='shape'
			/>
			<rect x='550.18' y='838.64' width='69.16' height='20' fill='none' className='shape' />
			<path
				d='M553.96,839.73c.99-.2,2.16-.33,3.47-.33,1.67,0,2.87.34,3.73,1.11.75.61,1.16,1.47,1.16,2.52,0,2.04-1.65,3.56-3.48,4.04v.06c1.46.43,2.67,1.64,2.65,3.59,0,1.66-.88,2.96-1.94,3.75-1.28.96-3.07,1.33-5.24,1.33-1.39,0-2.6-.08-3.35-.23l2.99-15.83ZM553.19,854.07c.5.08,1.09.1,1.64.1,2.36.01,4.57-.97,4.57-3.56,0-1.9-1.6-2.73-3.42-2.73h-1.62l-1.17,6.19ZM554.67,846.37h1.48c2.32,0,4.11-1.2,4.11-3.17,0-1.56-1.18-2.22-2.93-2.22-.73,0-1.34.05-1.65.15l-1,5.24Z'
				className='shape'
			/>
			<path
				d='M565.72,855.68l2.22-11.61h1.99l-2.22,11.61h-1.99ZM568.3,840.83c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.79-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path d='M573.64,855.68l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M592.7,848.64c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM583.77,851.1c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M599.25,844.08l1.13,2.53c.33.75.55,1.32.78,1.86h.07c.44-.64.71-1.05,1.27-1.76l2.14-2.63h2.3l-4.89,5.65,2.75,5.96h-2.17l-1.17-2.62c-.39-.87-.57-1.31-.84-2.07h-.07c-.34.55-.69,1.1-1.19,1.78l-2.35,2.92h-2.31l5.09-5.98-2.7-5.63h2.16Z'
				className='shape'
			/>
			<path
				d='M609.28,855.68l2.22-11.61h1.99l-2.22,11.61h-1.99ZM611.86,840.83c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.03.79-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<polygon
				points='597.69 204.11 597.8 208.44 602.35 208.44 597.87 211.11 597.97 215.43 595.1 212.76 590.62 215.43 593.32 211.11 590.44 208.44 594.99 208.44 597.69 204.11'
				className='shape'
			/>
			<rect x='518.68' y='185.31' width='77.75' height='20' fill='none' className='shape' />
			<path
				d='M524.97,187.9h-4.73l.34-1.73h11.46l-.34,1.73h-4.75l-2.74,14.45h-1.99l2.74-14.45Z'
				className='shape'
			/>
			<path
				d='M543.11,190.74l-1.56,8.23c-.25,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.03,1.51-2.56,2.46-4.1,2.46s-3.06-.72-3.06-3.36c0-.56.07-1.19.22-1.95l1.25-6.56h1.99l-1.23,6.47c-.12.65-.2,1.2-.2,1.7,0,1.2.49,2.02,1.86,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path
				d='M545.79,207.1l2.32-12.25c.26-1.4.5-2.94.65-4.11h1.82l-.33,2.19h.05c1.05-1.53,2.58-2.45,4.18-2.45,2.52,0,3.58,2.07,3.58,4.19,0,4.09-2.93,7.94-6.8,7.94-1.23,0-2.05-.27-2.5-.52h-.05l-.94,5.01h-1.98ZM549.06,200.4c.51.4,1.26.64,2.21.64,2.57,0,4.71-3.19,4.71-6.22,0-1.22-.54-2.69-2.23-2.69-1.57,0-3.51,1.78-4.12,5.03l-.59,3.24Z'
				className='shape'
			/>
			<path
				d='M570.3,201.69c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.43,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM568.1,192.03c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.76-1.48Z'
				className='shape'
			/>
			<path d='M575.23,202.35l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M594.29,195.31c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM585.36,197.77c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<polygon
				points='543.82 748.29 543.93 752.61 548.47 752.61 543.99 755.28 544.1 759.61 541.22 756.94 536.75 759.61 539.45 755.28 536.57 752.61 541.12 752.61 543.82 748.29'
				className='shape'
			/>
			<rect x='401.58' y='723.57' width='140.98' height='20' fill='none' className='shape' />
			<path
				d='M407.4,724.44l-1.31,6.82h7.44l1.3-6.82h2l-3.08,16.18h-1.99l1.44-7.6h-7.44l-1.43,7.6h-1.99l3.08-16.18h1.99Z'
				className='shape'
			/>
			<path
				d='M427.43,740.61c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.5,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM428.72,730.49c-.28-.09-.71-.17-1.38-.17-3,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.68-3.5Z'
				className='shape'
			/>
			<path
				d='M439.9,725.89l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M449.84,725.89l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M454.58,740.61l2.22-11.61h1.99l-2.22,11.61h-1.99ZM457.16,725.76c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.03.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M470.87,739.95c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.43,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM468.67,730.29c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.76-1.48Z'
				className='shape'
			/>
			<path
				d='M475.89,738.6c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.59,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.82-4.43,3.82-1.25,0-2.36-.39-2.89-.79l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M492.29,723.57l-1.53,7.53h.05c1.03-1.55,2.52-2.36,4.08-2.36,2.54,0,3.52,2.1,3.52,4.16,0,3.57-2.58,7.98-7.23,7.98-2.04,0-3.58-.85-3.58-3,0-.57.1-1.25.2-1.8l2.5-12.51h1.99ZM489.77,736.13c-.08.39-.15.85-.14,1.47.01,1.1.64,1.71,1.88,1.71,3.01,0,4.82-3.57,4.82-6.15,0-1.44-.63-2.77-2.22-2.77-1.71,0-3.5,1.78-4.08,4.5l-.26,1.23Z'
				className='shape'
			/>
			<path
				d='M513.51,729.01l-1.56,8.23c-.24,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.04,1.51-2.56,2.46-4.1,2.46s-3.07-.72-3.07-3.36c0-.56.07-1.18.22-1.95l1.26-6.56h1.99l-1.23,6.47c-.12.64-.2,1.2-.2,1.7,0,1.2.49,2.02,1.86,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path
				d='M517.24,740.61l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M527.21,743.25c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.72.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1.01-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM536.13,730.73c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
		</svg>
	);
};

MississippiMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default MississippiMap;
